import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as actionsHeader } from '../../redux/actions/site';
import './Modal.scss';

const Modal = props => {
    const dispatch = useDispatch();
    const modal = useSelector(state => state.site.modal);

    const renderActions = () => {
        if(modal.actions){

            return modal.actions.map((action, index) => {
                return (
                <button key={index} className={action.class}
                onClick={
                    (e) => {
                        e.stopPropagation(); action.callback(action.arg)
                    }
                }
                >{action.label}</button>
                )
            })
        }
    }

    const close = () => {
        if(modal.callbackCancel){
            modal.callbackCancel(modal.argCancel);
        } else {
            dispatch(actionsHeader.setModal(null));
        }
    }

    return (
        <div className="overlayModal">
            <div className="modal">
                <div className="header">
                    <div className="title">
                        {modal.title}
                    </div>
                    <div className="iconClose" onClick={close}>
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </div>
                </div>
                <div className="body">
                    <div className="msg">
                        <span dangerouslySetInnerHTML={{ __html: modal.msg }}></span>
                    </div>
                    {modal.component && modal.component}
                    <div className="actions">
                        {renderActions()}
                        <button className="vermelho" onClick={close}>Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Modal;